import React from 'react'
import '../css/Menuitem.css'
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function Menuitem(props) {
    return (
        <div>
        
            <div id="item">
                {props.itemname}
            </div>

           
        </div>
    )
}

export default Menuitem
